module.exports = __webpack_public_path__ + "10febed784cc63aac0dcd5b196142182.svg";